module.exports = {
  clinician: 'clinician',
  admin: 'admin',
};
